// decorators/dependency.ts
import { baseqlMetaData } from "@adornis/baseql/metadata/metaDataStore.js";
var dependencyPropertyName = "dependencies";
function Dependencies(dependencies) {
  return (target, propertyName) => {
    let currentField = target.fields[propertyName];
    if (!currentField)
      throw new Error("Could not find field " + propertyName + " to put on property!");
    currentField[dependencyPropertyName] = dependencies;
  };
}
function getDependenciesFromField(classType, propertyName) {
  return baseqlMetaData.entities.resolveNode(classType).fields[propertyName]?.[dependencyPropertyName];
}
async function getClassDependenciesForFieldName(classType, propertyName) {
  const dependencies = getDependenciesFromField(classType, propertyName);
  if (!dependencies || typeof dependencies.classes !== "function")
    return [];
  return await dependencies.classes();
}
async function getIDDependenciesForFieldName(classType, propertyName, node) {
  const dependencies = getDependenciesFromField(classType, propertyName);
  if (!dependencies || typeof dependencies.ids !== "function")
    return [];
  return await dependencies.ids.apply(node);
}
export {
  Dependencies,
  dependencyPropertyName,
  getClassDependenciesForFieldName,
  getIDDependenciesForFieldName
};
